export default __webpack_public_path__ + "static/media/iconTitle.7d6df247.svg";